import { Table } from "@chakra-ui/react"
import { DateTime } from "luxon"

export default function FileRow ({file, onClick}) {
  return(
    <Table.Row onClick={onClick} className="hover:cursor-pointer lg:hover:bg-grey-700 ">
      <Table.Cell className="w-1/4 overflow-hidden text-ellipsis whitespace-nowrap max-w-xs">{file.attributes.name ?? ''}</Table.Cell>
      <Table.Cell className="w-1/4 overflow-hidden text-ellipsis whitespace-nowrap max-w-xs">{file.attributes.folder.data?.attributes['directory-name'] ?? 'Root Folder'}</Table.Cell>
      <Table.Cell className="w-1/4 overflow-hidden text-ellipsis whitespace-nowrap max-w-xs">{DateTime.fromISO(file.attributes['created-at']).toLocaleString()}</Table.Cell>
      <Table.Cell className="w-1/4 overflow-hidden text-ellipsis whitespace-nowrap max-w-xs">{file.attributes['created-by-name'] ?? 'N/A'}</Table.Cell>
    </Table.Row>
  )
}